"use strict";

/**
 * @module Client.Services
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notifySubscriptionService = void 0;
/**
 * Notify subscriptions
 */
exports.notifySubscriptionService = {
  /**
   * Handle an inbound request.
   *
   * @param internal      the internal session instance
   * @param notification  the inbound notification
   * @param callback      the service reference callback
   */
  onRequest: function onRequest(internal, request, callback) {
    callback.respond();
    internal.getRouting().subscribe(request);
  }
};